module.exports = __webpack_public_path__ + "img/section_1.b95526d3.svg";